// extracted by mini-css-extract-plugin
module.exports = {"breadCrumbs":"product-breadcrumbs_breadCrumbs__hD4I3","breadCrumb":"product-breadcrumbs_breadCrumb__29Z9T","breadCrumbsSeparator":"product-breadcrumbs_breadCrumbsSeparator__Kq5WN"};